import React from "react";
import DateRangeField from "@/ui/forms/DateRangeField";
import { FilterInputProps } from "./FilterInput.types";
import { FILTER_INPUT_HEIGHTS } from "../../DataTable.theme";

/**
 * Date range filter input component.
 */
export const DateRangeFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
  placeholder = "Seleziona periodo...",
}) => {
  const range = value as { from: string; to: string } | null;
  const dateRange: [Date | null, Date | null] = [
    range?.from ? new Date(range.from) : null,
    range?.to ? new Date(range.to) : null,
  ];

  return (
    <DateRangeField
      value={dateRange}
      onChange={([start, end]) => {
        if (!start && !end) {
          onChange(null);
        } else {
          onChange({
            from: start ? start.toISOString() : "",
            to: end ? end.toISOString() : "",
          });
        }
      }}
      placeholder={placeholder}
      fullWidth
      clearable
      sx={{
        "& .MuiInputBase-root": {
          fontSize: density === "compact" ? "0.75rem" : "0.875rem",
          height: FILTER_INPUT_HEIGHTS[density],
        },
        width: "100% !important", // Override fixed width for filter row
      }}
    />
  );
};
